"use client";

import React, { useEffect, useState } from "react";
import Link from "next/link";
import "./holiday-book.css";
import { fetchAPI } from "../../utils/api";

const LifestylePop = ({
  backgroundImage,
  title,
  serviceTitle,
  subtext,
  title2,
  subtext2,
  popUpContent,
  logo1,
  logo2,
  logo3,
  button1,
  button2,
  contentAlign,
  popUpImage,
}) => {
  const [isBookingOpen, setIsBookingOpen] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [token, setToken] = useState(null);

  const openBookingModal = () => {
    if (serviceTitle) {
      getFLPBookingLink(serviceTitle);

      return;
    }

    setIsBookingOpen(true);
  };
  const closeBookingModal = () => setIsBookingOpen(false);

  useEffect(() => {
    // Get the access token from local storage
    if (typeof window !== "undefined") {
      setToken(window.localStorage.getItem("flp-access-token"));
    }
  }, []);

  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      window.localStorage.getItem("flp-token")
    ) {
      fetchAPI(
        `/ContactDetail?MemberID=${window.localStorage.getItem(
          "flp-member-id"
        )}`,
        "GET",
        null,
        typeof window !== "undefined" &&
          window.localStorage.getItem("flp-access-token")
      )
        .then((res) => {
          res.MemberID = window.localStorage.getItem("flp-member-id");
          setUserDetails(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [token]);

  const getFLPBookingLink = async (service) => {
    const res = await fetchAPI(
      `/GetFLPMemberLLToken?MemberNumber=${
        !(
          typeof window !== "undefined" &&
          window.localStorage.getItem("flp-token")
        )
          ? "00000"
          : userDetails?.MemberNumber
      }&returnurl=${service}`,
      "GET",
      null,
      null
    );

    window.open(res?.Data, "_blank");
  };

  const alignment = contentAlign === "left" ? "flex-start" : "flex-end";

  // Custom function to render Content
  const renderContent = (content) => {
    // Check if content is an array
    if (Array.isArray(content)) {
      return content.map((item, index) => <div key={index}>{item}</div>);
    } else if (typeof content === "string") {
      // If content is a string, render it as HTML
      return <div dangerouslySetInnerHTML={{ __html: content }} />;
    } else {
      // Fallback for non-string and non-array content
      return <div>{content}</div>;
    }
  };

  return (
    <section className="section-bg" id={title}>
      <div
        className="lifestyle-cont"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          alignItems: alignment,
        }}
      >
        <div className="overlay"></div>
        <div className="content-cont">
          <h1>{title}</h1>
          <p>{renderContent(subtext)}</p>
          <h1>{title2}</h1>
          <p>{renderContent(subtext2)}</p>
          <div className="logos-cont">
            <div
              className={
                logo1.visibility ? "logo-cont visible" : "logo-cont hidden"
              }
            >
              <img src={logo1.src} alt={logo1.alt} />
            </div>
            <div
              className={
                logo2.visibility ? "logo-cont visible" : "logo-cont hidden"
              }
            >
              <img src={logo2.src} alt={logo2.alt} />
            </div>
            <div
              className={
                logo3.visibility ? "logo-cont visible" : "logo-cont hidden"
              }
            >
              <img src={logo3.src} alt={logo3.alt} />
            </div>
          </div>
          {button1.book ? (
            <button
              className={button1.visibility ? "btn visible" : "btn hidden"}
              onClick={button1.book ? openBookingModal : null}
            >
              {button1.text}
            </button>
          ) : (
            <Link href={button1.link}>
              <button
                className={button1.visibility ? "btn visible" : "btn hidden"}
              >
                {button1.text}
              </button>
            </Link>
          )}
          {button2.book ? (
            <button
              className={button2.visibility ? "btn visible" : "btn hidden"}
              onClick={button2.book ? openBookingModal : null}
            >
              {button2.text}
            </button>
          ) : (
            <Link href={button2.link}>
              <button
                className={button2.visibility ? "btn visible" : "btn hidden"}
              >
                {button2.text}
              </button>
            </Link>
          )}
          <p className="uia">
            use in <span className="usinapp"> App</span>
            <span className="usinweb">Website</span>
          </p>
        </div>
        {isBookingOpen && (
          <div className="booking-Pop-cont">
            <button className="close" onClick={closeBookingModal}>
              &times;
            </button>
            <h2>MAKE THE BEST OF YOUR BENEFITS</h2>
            <div className="booking-card-cont">
              <div className="booking-card">
                <Link
                  href={"/"}
                  onClick={(e) => {
                    e.preventDefault();
                    getFLPBookingLink("hotels");
                  }}
                >
                  <img
                    src="/images/Holidays-Hotels-Book.png"
                    alt="Holidays Hotels & Resorts"
                  />
                  <p>Holidays Hotels & Resorts</p>
                </Link>
              </div>
              <div className="booking-card">
                <Link
                  href={"/"}
                  onClick={(e) => {
                    e.preventDefault();
                    getFLPBookingLink("cruises");
                  }}
                >
                  <img
                    src="https://nouf-flp-images.s3.af-south-1.amazonaws.com/Cruises-Book.png"
                    alt="Cruises"
                  />
                  <p>Cruises</p>
                </Link>
              </div>
              <div className="booking-card">
                <Link
                  href={"/"}
                  onClick={(e) => {
                    e.preventDefault();
                    getFLPBookingLink("flights");
                  }}
                >
                  <img
                    src="https://nouf-flp-images.s3.af-south-1.amazonaws.com/Flights-Book.png"
                    alt="Flights"
                  />
                  <p>Flights</p>
                </Link>
              </div>
              <div className="booking-card">
                <Link
                  href={"/"}
                  onClick={(e) => {
                    e.preventDefault();
                    getFLPBookingLink("cars");
                  }}
                >
                  <img src="/images/Car-Hire-Book.png" alt="Car Hire" />
                  <p>Car Hire</p>
                </Link>
              </div>
              <div className="booking-card">
                <Link
                  href={"/"}
                  onClick={(e) => {
                    e.preventDefault();
                    getFLPBookingLink("activities");
                  }}
                >
                  <img
                    src="/images/Tours-Activities-Book.png"
                    alt="Tours & Activities"
                  />
                  <p>Tours & Activities</p>
                </Link>
              </div>
              <div className="booking-card card-overlay">
                <div className="iao-overlay-cont">
                  <img
                    src="/images/Dining-Coffee-Book.png"
                    alt="Dining & Coffee"
                  />
                  <div className="iao-overlay">
                    <span>In App Only</span>
                  </div>
                </div>
                <p>Dining & Coffee</p>
              </div>
              <div className="booking-card card-overlay">
                <div className="iao-overlay-cont">
                  <img src="/images/Movies-Book.png" alt="Movies" />
                  <div className="iao-overlay">
                    <span>In App Only</span>
                  </div>
                </div>
                <p>Movies</p>
              </div>
              <div className="booking-card card-overlay">
                <div className="iao-overlay-cont">
                  <img src="/images/Spa-Book.png" alt="Spa" />
                  <div className="iao-overlay">
                    <span>In App Only</span>
                  </div>
                </div>
                <p>Spa</p>
              </div>
              <div className="booking-card card-overlay">
                <div className="iao-overlay-cont">
                  <img src="/images/Deals-4-U-Book.png" alt="Deals-4-U" />
                  <div className="iao-overlay">
                    <span>In App Only</span>
                  </div>
                </div>
                <p>Deals-4-U</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default LifestylePop;
